import { OrderComponentPropertyConfiguration } from "./orderComponentPropertyConfiguration";

export interface OrderComponent {
  id?: number;
  componentName?: string;
  componentLabel?: string;
  additionalClasses?: string;
  properties?: Array<OrderComponentPropertyConfiguration>;
}

export const ComponentNames = {
  multiOption: "multi-option",
  levelOfCare: "levelOfCare",
  careLocation: "careLocationType",
  reasonForGIP: "reasons-for-gip",
};



// WEBPACK FOOTER //
// ./src/models/order-management/orderComponent.ts